import { render, staticRenderFns } from "./border-item.vue?vue&type=template&id=0d6621ee&scoped=true"
import script from "./border-item.vue?vue&type=script&lang=js"
export * from "./border-item.vue?vue&type=script&lang=js"
import style0 from "./border-item.vue?vue&type=style&index=0&id=0d6621ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6621ee",
  null
  
)

export default component.exports